<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>

export default {
  name: 'App',

}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 确保根容器占满视口，无空白 */
#app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
</style>
